import getCsrfToken from '../../../asebi/lib/csrfToken';

declare var Urls: any;

export async function logout() {
  const url = Urls['rest_framework:logout']();

  const headers: HeadersInit = new Headers();
  const token = getCsrfToken();
  if (token !== undefined) {
    headers.set('X-CSRFToken', token);
  }

  const resp = await fetch(url, {
    method: 'POST',
    headers: headers
  });

  return true;
}

export async function auth(email: string, pw: string) {
  const token_path = '/api/users/csrf_cookie';
  const token_resp = await fetch(token_path);

  const path = '/api/users/auth';

  const data = new FormData();
  data.append('username', email);
  data.append('password', pw);

  const headers: HeadersInit = new Headers();
  const token = getCsrfToken();
  if (token !== undefined) {
    headers.set('X-CSRFToken', token);
  }

  const resp = await fetch(path, {
    method: 'POST',
    headers: headers,
    body: data
  });

  let msg = '';
  if (resp.redirected !== true) {
    const json = await resp.json();
    if (json.result === 'failed') {
      msg = 'ユーザIDまたはパスワードが正しくありません。';
    } else if (json.result === 'expired') {
      msg = 'アカウントの有効期限が切れています。お問い合わせ画面からアカウントの利用期間の延長を申請してください。';
    } else if (json.result === 'unregistered') {
      msg = '管理者によってアカウントの有効期限が登録されていません。お問い合わせ画面からアカウントの有効期限登録を申請してください。';
    }
    return [false, msg];
  } else {
    return [true, msg];
  }
}
